import { render, staticRenderFns } from "./upgradeGetCard.vue?vue&type=template&id=77bd81a1&"
import script from "./upgradeGetCard.vue?vue&type=script&lang=js&"
export * from "./upgradeGetCard.vue?vue&type=script&lang=js&"
import style0 from "./upgradeGetCard.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports